import axios from "axios";

const API = process.env.REACT_APP_API_URL;

export const getActiveIngredients = async (params) => {
	const { data } = await axios.get(`${API}/admin/active_ingredients`, {
		params,
	});
	return data;
};

export const getActiveIngredient = async (params) => {
	const { data } = await axios.get(`${API}/admin/active_ingredients/detail`, {
		params,
	});
	return data;
};

export const saveActiveIngredient = async (params) => {
	const { data } = await axios.post(`${API}/admin/active_ingredients/save`, params);
	return data;
};

export const deleteActiveIngredient = async (params) => {
	const { data } = await axios.post(`${API}/admin/active_ingredients/delete`, params);
	return data;
};
